<div class="notification-body">
  <ul class="bullet-points">
    <li>{{ 'TGA.Notifications.' + notification().type + '.Description1' | translate }}</li>
    <li>{{ 'TGA.Notifications.' + notification().type + '.Description2' | translate }}</li>
  </ul>
  @if (notification().cropFields.length > 1) {
    <p class="cropFieldsText">{{ 'cropFields' | translate }}:</p>
    <ul class="bullet-points">
      @for (cropField of notification().cropFields; track cropField.cropFieldId) {
        <li>
          {{ cropField.cropFieldName }}
        </li>
      }
    </ul>
  }
</div>
